import { render, staticRenderFns } from "./WhatIsNewModal.vue?vue&type=template&id=7ca81c9d&scoped=true&"
import script from "./WhatIsNewModal.vue?vue&type=script&lang=ts&"
export * from "./WhatIsNewModal.vue?vue&type=script&lang=ts&"
import style0 from "./WhatIsNewModal.vue?vue&type=style&index=0&id=7ca81c9d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca81c9d",
  null
  
)

export default component.exports